import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LabOrderRepository } from '../../api/lab-order/lab-order.repository';
import { LabOrder } from '../../api/lab-order/model/labOrder';
import { LabOrderAccount } from '../../api/lab-order/model/labOrderAccount';
import { LabOrderReport } from '../../api/lab-order/model/labOrderReport';
import { LabOrderPatient } from '../../api/lab-order/model/labOrderPatient';

@Injectable({
  providedIn: 'root',
})
export class LabOrderService {
  public patient$: Observable<LabOrderPatient | null>;
  private readonly patient: BehaviorSubject<LabOrderPatient | null>;

  constructor(private readonly labOrderRepository: LabOrderRepository) {
    this.patient = new BehaviorSubject<LabOrderPatient | null>(null);
    this.patient$ = this.patient.asObservable();
  }

  public setPatient(patient: LabOrderPatient): void {
    this.patient.next(patient);
  }

  public saveLabOrder(labOrder: LabOrder, efan: string, labOrderAccount?: LabOrderAccount): Observable<LabOrder> {
    labOrder.status = 'SAVED_00';
    this.updateAccount(labOrder, efan, labOrderAccount);
    return this.chooseSavingPath(labOrder);
  }

  public submitLabOrder(labOrder: LabOrder): Observable<LabOrder> {
    labOrder.status = 'SUBMIT_05';
    return this.labOrderRepository.saveLabOrderExisting(labOrder);
  }

  public getLabOrder(inputLabOrderNumber: string): Observable<LabOrder> {
    return this.labOrderRepository.getLabOrder(inputLabOrderNumber);
  }

  public getDSR(inputLabOrderNumber: string): Observable<LabOrderReport> {
    return this.labOrderRepository.getDSR(inputLabOrderNumber);
  }

  private updateAccount(labOrder: LabOrder, efan?: string, labOrderAccount?: LabOrderAccount) {
    if (labOrder.account) {
      labOrder.account.efan = efan;
      labOrder.account.officeId = labOrderAccount?.officeId;
      labOrder.account.officePhone = labOrderAccount?.officePhone;
    } else {
      labOrder.account = {
        efan: efan,
        officeId: labOrderAccount?.officeId,
        officePhone: labOrderAccount?.officePhone,
      } as LabOrderAccount;
    }
  }

  private chooseSavingPath(labOrder: LabOrder) {
    return labOrder.labOrderNumber ? this.labOrderRepository.saveLabOrderExisting(labOrder) : this.labOrderRepository.saveLabOrderNew(labOrder);
  }
}
